import React from 'react'
import './App.css'

let origin = window.location.origin
origin = origin.replace(/:3000/, '')

class App extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      ready: false,
      error: null,
      card: null,
      deckCount: null,
      kingCount: null
    }

    this.initialise = this.initialise.bind(this)
    this.drawCard = this.drawCard.bind(this)
    this.undoMove = this.undoMove.bind(this)
    this.shuffleDeck = this.shuffleDeck.bind(this)
  }

  componentDidMount() {
    // fetch(`${origin}/node_servers/ring_of_fire/start_server.php`)
    // .then(r => r.text())
    // .then(response => {
    //   if (response.match(/^success: /)) {
      this.initialise()
    //   }
    //   else {
    //     throw new Error(response)
    //   }
    // })
    // .catch(e => {
    //   this.setState({ error: e.message })
    // })
  }

  render() {
    if (this.state.error) {
      return (
        <div className='error-modal'>{this.state.error}</div>
      )
    }
    else if (this.state.ready) {
      return (
        <div className='App'>
          <div className='card'>
            <img src={this.getCardSrc(this.state.card)} alt='' />
          </div>
          <button className='draw-button button' onClick={this.drawCard}>DRAW</button>
          <button className='undo-button button' onClick={this.undoMove}>UNDO</button>
          <button className='shuffle-button button' onClick={this.shuffleDeck}>SHUFFLE</button>
        </div>
      )
    }
  }

  initialise() {
    const server_location = 'ring_of_fire'
    const protocol = window.location.protocol === 'http:' ? 'ws:' : 'wss:'
    const websocket = new WebSocket(`${protocol}//${window.location.hostname}/ws/${server_location}`)

    websocket.onmessage = message => {
      if (message.data === 'ping') {
        return
      }

      const state = JSON.parse(message.data)
      this.setState({
        card: state.card,
        deckCount: state.deck_count,
        kingCount: state.king_count
      })
    }

    websocket.onclose = () => {
      this.setState({ error: 'connection lost to server'})
    }

    this.websocket = websocket
    this.setState({ ready: true })
  }

  drawCard() {
    if (this.websocket) {
      this.websocket.send('draw_card')
    }
  }

  undoMove() {
    if (this.websocket) {
      this.websocket.send('undo_move')
    }
  }

  shuffleDeck() {
    if (this.websocket) {
      this.websocket.send('shuffle_deck')
    }
  }

  getCardSrc(card) {
    if (!card) {
      if (this.state.deckCount === 0) {
        return `${origin}/resources/playing_cards/card_slots/card_slot.svg`
      }
      else {
        return `${origin}/resources/playing_cards/card_backs/red_dots.svg`
      }
    }

    if (card.endsWith('J')) {
      return `${origin}/resources/playing_cards/jokers/FACE_${card}.svg`
    }

    return `${origin}/resources/playing_cards/large_index/${card}.svg`
  }
}

export default App;
